export const SaveBanner = () => (
  <div className="save-banner" data-testid="save-banner">
    $$$$$ SAVE — NO WELDING REQUIRED — SAVE $$$$$
  </div>
);
